module.exports = __webpack_public_path__ + "static/media/emptyState.810fe338.svg";